import * as React from 'react';
import { EProjectType } from '../../../../enum/project';
import { useAppSelector } from '../../../../../reduxService/hooks';
import { selectProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import BasinDesignVertical from './BasinDesignVertical';
import BasinDesignSloped from './BasinDesignSloped';
import BasinDesignStepped from './BasinDesignStepped';

interface IBasinDesignResultsProps {}

const BasinDesignResults = (props: IBasinDesignResultsProps) => {
    const projectInfo = useAppSelector(selectProjectInfo);

    let canvas: JSX.Element;

    switch (projectInfo.data!.type) {
        case EProjectType.Macra2 | EProjectType.VerticalDrop:
            canvas = <BasinDesignVertical />;
            break;
        case EProjectType.Macra2 | EProjectType.SlopedWeir:
            canvas = <BasinDesignSloped />;
            break;
        case EProjectType.Macra2 | EProjectType.SteppedWeir:
            canvas = <BasinDesignStepped />;
            break;
        default:
            canvas = <></>;
            break;
    }

    return canvas;
};

export default BasinDesignResults;
